import * as React from 'react';
import MaterialTable, {MTableBodyRow, MTableFilterRow, MTableToolbar} from 'material-table';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import FolderOpenIcon from '@material-ui/icons/FolderOpen';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import {DeleteConfirmation} from './DeleteConfirmation';
import {PopoverPosition} from '@material-ui/core/Popover';
import {ApplicationState} from '../../store';
import {connect} from 'react-redux';
import {Tab} from '../Tab';
import {actionSetTabState} from "../../store/tabs/actions";
import {ColumnData} from '../../models/ColumnData';
import {Button, Grid, Paper, TablePagination, TextField, Typography} from '@material-ui/core';
import {AttributeDescriptor, BaseModel, BaseModelDescriptor} from '../../models/BaseModel';
import {t} from "../../core/localization";
import {Formater, FormatTypes} from "../../core/Formater";
import {AppConfig} from "../../config";
import {FinanceType} from '../../models/CustomerFinances';
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";

export interface GenericListProps<RowData extends BaseModel> {
	columns: ColumnData<RowData>[] ;
	items: RowData[];
	title: string;
	onOpenClick?: (selectedRow: RowData) => void;
	onCopyClick?: (selectedRow: RowData) => void;
	onDeleteClick?: (selectedRow: RowData) => void;
	onActionDeleteClick?: (selectedRows: RowData[]) => void;
	tab: Tab
	descriptor?: BaseModelDescriptor
	rowStyle?: (rowData: RowData) => {}
}

export interface GenericListState<> {
	contextMenuPosition: PopoverPosition;
	selectedRow: any;
	isDialogOpen?: boolean;
	selectedData?: any;
	isActionDialogOpen?: boolean;
}

function mapStateToProps(state: ApplicationState) {
	return {
		tab: state.tabs.active
	};
}

export class GenericList<RowData extends BaseModel> extends React.Component<GenericListProps<RowData>, GenericListState> {

	constructor(props: GenericListProps<RowData>) {

		super(props);
		this.tableRef = React.createRef();
		this.state = this.getInitialState();
	}

	tableRef: any;

	getInitialState(): GenericListState {
		return {
			contextMenuPosition: null,
			selectedRow: null,
			isDialogOpen: false,
			isActionDialogOpen: false
		};
	}

	componentWillReceiveProps(nextProps: GenericListProps<RowData>) {
	}

	componentDidMount() {
		const {tab} = this.props;

		let tableComponent = this.tableRef.current;
		if (tableComponent.onSearchChange) {
			tableComponent.onSearchChange(tab.state['searchText']);
		} else {
			console.log('onSearchChange does not exist on ' + this.tableRef.current)
		}
	}

	componentDidUpdate() {
		const {tab} = this.props;

		let tableComponent = this.tableRef.current;

		if (tab.state['page'] > 0)
			tableComponent.onChangePage(null, tab.state['page']);

		// if(tab.state['eventChangeRowsPerPage'])
		//   tableComponent.onChangeRowsPerPage(tab.state['eventChangeRowsPerPage']);
		//
		// if(tab.state['eventChangePage'])
		//   tableComponent.onChangePage(tab.state['eventChangePage'], tab.state['page']);
	}

	rowClick(event?: React.MouseEvent, rowData?: RowData) {
	}

	onRowClick(event?: React.MouseEvent, rowData?: RowData) {
		if (event.button == 2) {
			event.preventDefault();

			this.setState({
				contextMenuPosition: {top: event.pageY, left: event.pageX},
				selectedRow: rowData,
			});
		}
	}

	onRowDoubleClick(event?: React.MouseEvent, rowData?: RowData) {
		this.props.onOpenClick(rowData);
	}

	onMenuClose() {
		this.clearSelectedRow();
	}

	clearSelectedRow() {
		this.setState({
			contextMenuPosition: null,
			selectedRow: null
		});
	}

	closeContextMenu() {
		this.setState({
			contextMenuPosition: null,
		});
	}

	onActionOpenClick(data: RowData[]) {
		if (data && data.length === 1)
			this.props.onOpenClick(data[0]);
	}

	onActionCopyClick(data: RowData[]) {
		if (data && data.length === 1)
			this.props.onCopyClick(data[0]);
	}

	onActionDownloadClick(data: RowData[]) {
		alert('download')
	}

	onActionDeleteClick(data: RowData[]) {
		this.setState({...this.state, isActionDialogOpen: !this.state.isActionDialogOpen, selectedData: data});
	}

	onOpenClick(event: React.MouseEvent) {
		this.props.onOpenClick(this.state.selectedRow);
		this.clearSelectedRow();
	}

	onCopyClick(event: React.MouseEvent) {
		this.props.onCopyClick(this.state.selectedRow);
		this.clearSelectedRow();
	}

	onDeleteClick(event: React.MouseEvent) {
		this.setState({...this.state, isDialogOpen: true});
		this.closeContextMenu();
	}

	onDeleteConfirmClick() {
		this.props.onDeleteClick(this.state.selectedRow);
		this.setState({...this.state, isDialogOpen: false});
	}

	onActionDeleteConfirmClick() {

		if (this.state.selectedData) {
			if (this.props.onActionDeleteClick)
				this.props.onActionDeleteClick(this.state.selectedData);
		} else {
			// let items: RowData[] = [];
			// items.push(this.state.selectedRow)
			this.props.onDeleteClick(this.state.selectedRow);
		}

		this.setState({...this.state, isActionDialogOpen: false});

	}

	onToggleModal() {
		this.setState({...this.state, isDialogOpen: !this.state.isDialogOpen});
	}

	onToggleActionModal() {
		this.setState({...this.state, isActionDialogOpen: !this.state.isActionDialogOpen});
	}

	onOrderChange(orderBy: number, orderDirection: ("asc" | "desc")) {
		let tabState = this.props.tab.state;
		tabState['order'] = orderBy;
		tabState['orderDirection'] = orderDirection;
		actionSetTabState(tabState);
	}

	onChangeRowsPerPage(event: any, props: any) {
		let tabState = this.props.tab.state;
		tabState['pageSize'] = event.target.value;
		//tabState['eventChangeRowsPerPage'] = event
		actionSetTabState(tabState);

		if (props.onChangeRowsPerPage)
			props.onChangeRowsPerPage(event);
	}

	onChangePage(event: any, page: number, props: any) {
		let tabState = this.props.tab.state;
		tabState['page'] = page;
		//tabState['eventChangePage'] = event
		actionSetTabState(tabState);

		if (props.onChangePage)
			props.onChangePage(null, page);
	}

	onSearchChanged(searchText: string, props: any) {
		let tabState = this.props.tab.state;
		tabState['searchText'] = searchText;
		tabState['data'] = props.data;
		actionSetTabState(tabState);

		if (props.onSearchChanged)
			props.onSearchChanged(searchText);
	}

	onSelectionChange(data: RowData[], rowData?: RowData) {
		let tabState = this.props.tab.state;
		tabState['selectedData'] = data;
		tabState['rowData'] = rowData;
		actionSetTabState(tabState);
	}

	onFilterChanged(columnId: number, value: any, props: any) {
		if (props.onFilterChanged)
			props.onFilterChanged(columnId, value);

		let tabState = this.props.tab.state;
		tabState['columnId'] = columnId;
		tabState['value'] = value;

		// actionSetTabState(tabState);
	}


	renderFilterRow(props: any) {
		return (<MTableFilterRow
			{...props}
			onFilterChanged={(columnId: number, value: any) => this.onFilterChanged(columnId, value, props)}
		/>)
	}

	render() {

		const {items, columns, title, tab} = this.props;

		let content: string = null;
		let selectedData = this.state.selectedData;
		if (selectedData) {
			if (selectedData.length === 1)
				content = t.DeleteItemConfirmationMessage;
			else if (selectedData.length > 1)
				content = t.AreYouSureYouWantToDelete + ' ' + selectedData.length + ' ' + t.Items + ' ?';
		}

		let column = columns[tab.state['order']];
		if (column) {
			column.defaultSort = tab.state['orderDirection'];
		}

		let selectedItems = tab.state['selectedData'];
		if (selectedItems) {
			for (let i = 0; i < selectedItems.length; i++) {

				let item = items.find(x => x.id == selectedItems[i].id);

				if (item) {
					item.tableData = {
						checked: true
					};
				}
			}
		}

		let columnsCopy: any[] = []
		for (let column of columns) {
			let newColumn: any = {... column}
			if (column.documentField) {
				newColumn.field = column.documentField
			}
			columnsCopy.push(newColumn)
		}

		// todo: iterating twice, do it once
		// new object for items
		let itemsCopy = [];
		if (items) {
			for (let item of items) {
				let newItem = {...item};
				this.formatItem(newItem, this.props.descriptor);
				for (let column of columns) {
					if (column.documentField) {
						this.getDocumentField(newItem, column.field.toString(), column.documentField, column.format)
					}
				}
				itemsCopy.push(newItem);
			}
		}

		if (!tab.state['page'])
			tab.state['page'] = 0;

		if (!tab.state['pageSize'])
			tab.state['pageSize'] = AppConfig().tablePageSize;

		// let columnFilter = columns[tab.state['columnId']];
		// if (columnFilter) {
		// 	columnFilter.tableData = {
		// 		columnOrder: 0,
		// 		filterValue: tab.state['value'],
		// 		groupOrder: undefined,
		// 		groupSort: "asc",
		// 		id: 0,
		// 	};
		// }



		return (
			<div className={'ev-list'}>
				<MaterialTable
					columns={columnsCopy}
					data={itemsCopy}
					title={title}
					tableRef={this.tableRef}
					options={{
						actionsCellStyle: {},
						selection: true,
						filtering: true,
						pageSize: AppConfig().tablePageSize,
						rowStyle: rowData => {
							if (this.props.rowStyle) {
								return this.props.rowStyle(rowData)
							}
							return {};
						},
						exportButton: true,
						exportAllData: true
					}}
					onOrderChange={(orderBy: number, orderDirection: ("asc" | "desc")) => this.onOrderChange(orderBy, orderDirection)}
					onSelectionChange={(data: RowData[], rowData?: RowData) => this.onSelectionChange(data, rowData)}
					actions={[
						(rowData: any) => ({
							icon: () => <FolderOpenIcon/>,
							tooltip: rowData.length === 1 ? t.OpenSelectedItem : '',
							onClick: (event, data: RowData[]) => this.onActionOpenClick(data),
							disabled: rowData.length > 1
						}),
						(rowData: any) => ({
							icon: () => <FileCopyIcon/>,
							tooltip: rowData.length === 1 ? t.CopySelectedItem : '',
							onClick: (event, data: RowData[]) => this.onActionCopyClick(data),
							disabled: rowData.length > 1
						}),
						{
							tooltip: t.RemoveAllSelectedItems,
							icon: 'delete',
							onClick: (evt, data: RowData[]) => this.onActionDeleteClick(data)
						}
					]}

					localization={{
						pagination: {
							labelDisplayedRows: '{from}-{to} ' + t.Of + ' {count}',
							labelRowsSelect: t.Rows,
							firstTooltip: t.FirstPage,
							previousTooltip: t.PreviousPage,
							nextTooltip: t.NextPage,
							lastTooltip: t.LastPage
						},
						toolbar: {
							nRowsSelected: '{0} ' + t.RowsSelected,
							searchPlaceholder: t.Search,
							searchTooltip: t.Search
						},
						header: {
							actions: t.Actions
						},
						body: {
							emptyDataSourceMessage: t.NoRecordsToDisplay,
							filterRow: {
								filterTooltip: t.Filter
							}
						}
					}}


					//onRowClick={(event, rowData) => this.rowClick(event, rowData)}
					components={{
						Row: props => (
							<MTableBodyRow
								className={'ev-table-row'}
								{...props}
								onContextMenu={(event: any) => this.onRowClick(event, props.data)}
								onDoubleClick={(event: any) => this.onRowDoubleClick(event, props.data)}
							/>
						),
						FilterRow: props => {return this.renderFilterRow(props)},

						Toolbar: props => (<MTableToolbar
							{...props}
							searchText={tab.state['searchText']}
							onSearchChanged={(searchText: string) => this.onSearchChanged(searchText, props)}
						/>),

						Pagination: props => (<TablePagination
							{...props}
							page={tab.state['page']}
							rowsPerPage={tab.state['pageSize']}
							onChangePage={(event: any, page: number) => this.onChangePage(event, page, props)}
							onChangeRowsPerPage={(event: any) => this.onChangeRowsPerPage(event, props)}
						/>),
					}}
				/>
				<Menu
					id="simple-menu"
					keepMounted
					open={Boolean(this.state.contextMenuPosition)}
					anchorPosition={this.state.contextMenuPosition}
					anchorReference='anchorPosition'
					onClose={() => this.onMenuClose()}
				>
					<MenuItem onClick={(event) => this.onOpenClick(event)}>Open</MenuItem>
					<MenuItem onClick={(event) => this.onCopyClick(event)}>Copy</MenuItem>
					<MenuItem onClick={(event) => this.onDeleteClick(event)}>Delete</MenuItem>
				</Menu>

				<DeleteConfirmation
					isOpen={this.state.isDialogOpen}
					onDeleteConfirm={() => this.onDeleteConfirmClick()}
					onToggleModal={() => this.onToggleModal()}
				/>

				<DeleteConfirmation
					isOpen={this.state.isActionDialogOpen}
					onDeleteConfirm={() => this.onActionDeleteConfirmClick()}
					onToggleModal={() => this.onToggleActionModal()}
					content={content}
				/>

			</div>
		);
	}

	// private handleChange(e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>, name: string) {

	// 	//this.setState({name: e.currentTarget.value})
	// 	let tabState = this.props.tab.state
	// 	tabState[name] = e.currentTarget.value
	// 	actionSetTabState(this.props.tab, tabState)
	// }

	private getFromTabState(tab: Tab, key: string) {
		if (tab.state[key]) return tab.state[key];
		return null;
	}

	private formatItem(item: any, descriptor: BaseModelDescriptor) {
		if (!descriptor) return;
		// @ts-ignore
		Object.keys(descriptor).forEach(function (key: string, value) {
			// @ts-ignore
			let attributeDescriptor: AttributeDescriptor = (descriptor as any)[key];

			if (attributeDescriptor.format) {
				item[key] = Formater.format(item[key], attributeDescriptor.format);
			}
		});
	}

	private getDocumentField(item: any, rootFieldName: string, filedName: string, format?: FormatTypes) {
		if (item[rootFieldName]) {
			let value = item[rootFieldName][filedName]
			if (format) {
				value = Formater.format(item[rootFieldName][filedName], format)
			}
			item[filedName] = value
		}

	}

}

export default connect(mapStateToProps)(GenericList);
